var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpotify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_223_11945)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 24.858,
    fill: "#1ED760"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1192 33.5197C33.7473 34.0948 32.9538 34.2558 32.3339 33.9107C27.4491 31.1506 21.3245 30.5296 14.0841 32.0476C13.3898 32.1856 12.6955 31.7946 12.5468 31.1506C12.398 30.5066 12.8195 29.8625 13.5138 29.7245C21.4237 28.0454 28.2178 28.7585 33.6729 31.8636C34.2928 32.2086 34.4912 32.9447 34.1192 33.5197ZM36.6484 28.2754C36.1773 28.9885 35.1854 29.1955 34.4168 28.7815C28.8377 25.5843 20.3327 24.6642 13.737 26.5273C12.8691 26.7573 11.9765 26.3203 11.7285 25.5383C11.4805 24.7332 11.9517 23.9052 12.8195 23.6752C20.3575 21.5591 29.7303 22.5711 36.1525 26.2283C36.8716 26.6423 37.1195 27.5624 36.6484 28.2754ZM36.8716 22.8011C30.1767 19.1209 19.1425 18.7759 12.7451 20.57C11.7285 20.869 10.6375 20.34 10.3151 19.3739C9.99279 18.4309 10.5879 17.4188 11.6045 17.1198C18.9441 15.0497 31.1437 15.4637 38.8304 19.696C39.7479 20.202 40.0454 21.306 39.4999 22.1571C38.9792 23.0311 37.789 23.3302 36.8716 22.8011Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_223_11945"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpotify);
export default __webpack_public_path__ + "static/media/Spotify.debd7593dfb84506e7c76cec0f9c341f.svg";
export { ForwardRef as ReactComponent };